
import { defineComponent } from '@vue/runtime-core'

export default defineComponent({
    data() {
        return {
            text: '',
        }
    },
    emits: ['search'],

    watch: {
        text() {
            this.text = this.text.match(/[a-z]+/gi)?.join('') || ''
            this.$emit('search', { text: this.text })
        },
    },

    methods: {
        inputBlur() {
            setTimeout(() => {
                this.text = ''
            }, 1000)
        },
    },
})
